<template>
  <form-section
    :title="$t('CampaignReport_Schedule_Title')"
    :description="$t('CampaignReport_Schedule_Description')"
  >
    <recurrence-settings
      class="recurrence-settings"
      :model="model.schedule"
      :timezone="$store.state.app.project.timezone"
      :is-campaign-report="true"
    />
    <report-switch
      :model="model"
      prop="start_from_campaign_creation"
      :title="$t('CampaignReport_FirstRunTypeSwitch_Label')"
      :description="$t('CampaignReport_FirstRunTypeSwitch_Description')"
      :tooltip="$t('CampaignReport_FirstRunTypeSwitch_Tooltip')"
      :disabled="
        isReportUpdateRoute || !$hasFeature('saveAsReportCampaignStartTime')
      "
    />
    <report-switch
      :model="model"
      prop="delta"
      :title="$t('CampaignReport_DeltaSwitch_Label')"
      :description="$t('CampaignReport_DeltaSwitch_Description')"
      :tooltip="$t('CampaignReport_DeltaSwitch_Tooltip')"
      :disabled="isReportUpdateRoute || $hasFeature('saveAsReportDelta')"
    />
    <repeat-input :model="model" :disabled="isReportUpdateRoute" />
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RecurrenceSettings from '@/modules/automations/components/RecurrenceSettings'
import ReportSwitch from '@/modules/campaign-manage/components/report/ReportSwitch.vue'
import RepeatInput from '@/modules/campaign-manage/components/report/RepeatInput.vue'

export default {
  name: 'Schedule',

  components: {
    RepeatInput,
    RecurrenceSettings,
    FormSection,
    ReportSwitch
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    isReportUpdateRoute() {
      return this.$route.name === 'UpdateCampaignReport'
    }
  }
}
</script>

<style scoped>
.recurrence-settings {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/report/Schedule.vue